import clsx from 'clsx';
import React, { CSSProperties, useRef } from 'react';
import { Icon } from '../../../icon/Icon';
import { Tooltip } from '../../../tooltip/Tooltip';
import { getDataIdGenerator } from '../../utils/dataId';
import styles from './styles.module.scss';

export interface HdMenuTriggerProps {
  className?: string;
  children: React.ReactNode;
  id: string;
  onClick: VoidFunction;
  disabled?: boolean;
  thumbnail?: string;
  thumbnailStyles?: CSSProperties;
  clearHorizontalGutter?: boolean;
  showDropdownIcon?: boolean;
  clearAllGutter?: boolean;
  overflowTooltipContent?: string;
}

export function ExternalDropdownTrigger({
  className = '',
  onClick,
  id,
  children,
  disabled,
  thumbnail,
  thumbnailStyles,
  clearHorizontalGutter,
  showDropdownIcon = true,
  clearAllGutter,
  overflowTooltipContent = ''
}: HdMenuTriggerProps) {
  const menuRef = useRef<HTMLButtonElement>(null);

  const dataIdGenerator = getDataIdGenerator(id, 'external-dropdown-trigger');

  return (
    <button
      ref={menuRef}
      type='button'
      id={id}
      data-id={dataIdGenerator}
      onClick={() => onClick()}
      className={clsx(styles.dropdownTrigger, className, {
        [styles.disabled]: disabled,
        [styles.clearSurroundingGutter]: clearAllGutter,
        [styles.clearHorizontalGutter]: !clearAllGutter && clearHorizontalGutter
      })}
      aria-describedby='hd-menu'
      aria-controls='hd-menu'
      aria-haspopup='true'
    >
      {thumbnail ? (
        <Icon name={thumbnail} className={styles.thumbnail} style={thumbnailStyles} />
      ) : null}

      <Tooltip
        dataId={dataIdGenerator('')}
        title={overflowTooltipContent}
        enableOnTextOverflow={!!overflowTooltipContent}
      >
        <span className='text-ellipsis flex-1'>{children}</span>
      </Tooltip>

      {showDropdownIcon ? <Icon name='dropdown-arrow' className={styles.icon} /> : null}
    </button>
  );
}
